// Currency / number / percent formatters. USD-only for v1.

// Defaults: standard notation shows cents (2 decimals) so every displayed
// number reconciles with the underlying value. Compact notation (chart axes)
// defaults to 0 decimals to keep axis labels short. Callers can override.
export const formatUSD = (n, opts = {}) => {
  const value = Number.isFinite(n) ? n : 0;
  const { compact = false, decimals } = opts;
  const finalDecimals = decimals !== undefined ? decimals : (compact ? 0 : 2);
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    notation: compact ? "compact" : "standard",
    maximumFractionDigits: finalDecimals,
    minimumFractionDigits: finalDecimals,
  }).format(value);
};

export const formatNumber = (n, decimals = 0) => {
  const value = Number.isFinite(n) ? n : 0;
  return new Intl.NumberFormat("en-US", {
    maximumFractionDigits: decimals,
    minimumFractionDigits: decimals,
  }).format(value);
};

export const formatPercent = (n, decimals = 1) => {
  const value = Number.isFinite(n) ? n : 0;
  return `${value.toFixed(decimals)}%`;
};

export const formatMonths = (n) => {
  if (!Number.isFinite(n)) return "—";
  return `${n.toFixed(1)} mo`;
};